import React from "react";
import { Helmet } from 'react-helmet';
import { useIntl} from 'react-intl';
import Layout from "../components/Layout";

//import { FormattedMessage, Link, useIntl } from "gatsby-plugin-react-intl"

//import withLayout from "../layout";
//import withPageContext from "../pageContext";


export default function NotFoundPage(){
    const intl = useIntl();
    const t = intl.formatMessage;
    
    return (
        <>
        <Helmet>
            <title>{t({ id: "language" })}</title>
        </Helmet>
        <Layout>
        <div>
        Oupss! This Page doesn't exist...

        Oupss! Cette page n'existe pas...

        </div>
        </Layout>
        </>
)}
